<template>
    <q-icon :size="size"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path :d="path" :fill="fill"></path></svg></q-icon>
</template>

<script>
export default {
  name: 'JobApplicationIcon',
  props: {
    path: { required: true, type: String, },
    fill: { required: false, type: String, default: 'currentColor' },
    size: { required: false, type: String, default: 'md' },
  },
}
</script>